import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import filter from 'lodash/filter';
import indexOf from 'lodash/indexOf';
import map from 'lodash/map';
import { bindActionCreators } from 'redux';
import SignInCards from '../../components/sign-in-cards';
import { getProductTeachers, printTeacherSignInCard } from '../teacher-roll/actions';
import { getProductClassrooms } from '../class-roll/actions';
import signInCardsEnum from './constants';
import { printSignInCard } from '../student-roll/actions';
import { DEFAULT_CLASSROOM_ID, DEFAULT_TEACHER_ID } from '../../constants';

class SignInCardsContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            filteredClassrooms: [],
            disableDownload: false,
            currentSelection: signInCardsEnum.STUDENTS
        };

        this.selectedLabelSize = signInCardsEnum.LABELS.DEFAULT_SIZE;
        this.schoolTeachers = [];
        this.selectedTeacherId = DEFAULT_TEACHER_ID;
        this.filteredClassrooms = [];
        this.selectedClassroomId = DEFAULT_CLASSROOM_ID;

        this.downloadStudentSignInCards = this.downloadStudentSignInCards.bind(this);
    }

    componentDidMount() {
        const { teachers, selectedProduct, classrooms } = this.props;
        if (!teachers.length) {
            this.props.getProductTeachers(selectedProduct.id);
        } else {
            this.getAllSchoolTeachers();
        }

        if (!classrooms.length) {
            this.props.getProductClassrooms(selectedProduct.id);
        } else {
            this.filteredClassrooms = this.filterClassroomsByStudentsCount(classrooms);
            this.onChangeCurrentSelection(signInCardsEnum.STUDENTS, this.filteredClassrooms);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isStudentSignInCardDownloaded === nextProps.isStudentSignInCardDownloaded) {
            const { classrooms } = nextProps;
            if (this.state.currentSelection && this.state.currentSelection === signInCardsEnum.STUDENTS) {
                this.filteredClassrooms = this.filterClassroomsByStudentsCount(classrooms);
                this.setState({ filteredClassrooms: this.filteredClassrooms });
                this.getAllSchoolTeachers();
            }
            this.onChangeCurrentSelection(this.state.currentSelection, this.filteredClassrooms);
        }
    }

    filterClassroomsByStudentsCount = classrooms => filter(classrooms, classroom => classroom.key === -1 || classroom.studentsCount)

    filterClassroomsByTeacher = (classrooms) => {
        const filteredClassrooms = filter(classrooms,
            classroom => classroom.key === -1 || indexOf(classroom.teachersId, Number(this.selectedTeacherId)) !== -1
        );
        return filteredClassrooms;
    }

    onTeacherSelectionChange = (name, value) => {
        const { classrooms } = this.props;
        if (value === DEFAULT_TEACHER_ID) {
            this.selectedTeacherId = DEFAULT_TEACHER_ID;
            this.filteredClassrooms = this.filterClassroomsByStudentsCount(classrooms);
        } else {
            this.selectedTeacherId = value;
            this.filteredClassrooms = this.filterClassroomsByTeacher(this.filterClassroomsByStudentsCount(classrooms));
        }
        this.selectedClassroomId = DEFAULT_CLASSROOM_ID;
        this.onChangeCurrentSelection(this.state.currentSelection, this.filteredClassrooms);
    }

    onClassSelectionChange = (name, value) => {
        this.selectedClassroomId = value;
    }

    getAllSchoolTeachers = () => {
        const { teachers } = this.props;
        const filteredTeachers = teachers.filter(teacher => teacher.key !== -1);
        this.schoolTeachers = map(filteredTeachers, teacher => teacher.key);
    }

    onLabelSelectionChange = (name, value) => {
        this.selectedLabelSize = value;
    }

    onChangeCurrentSelection = (value, filteredClassrooms) => {
        const { teachers } = this.props;

        let disableDownload = false;

        if (value === signInCardsEnum.STUDENTS) {
            disableDownload = filteredClassrooms && filteredClassrooms.length <= 1;
        } else if (value === signInCardsEnum.TEACHERS) {
            disableDownload = teachers.length <= 1;
        }
        this.setState({ currentSelection: value, disableDownload, filteredClassrooms });
    }

    downloadStudentSignInCards() {
        const studentSignInCardsData = { signInCardPageSizeType: this.selectedLabelSize };
        if (this.selectedClassroomId && this.selectedClassroomId !== DEFAULT_CLASSROOM_ID) {
            studentSignInCardsData.classroomId = Number(this.selectedClassroomId);
        }
        if (this.selectedTeacherId && this.selectedTeacherId !== DEFAULT_TEACHER_ID) {
            studentSignInCardsData.teacherUserProfileId = Number(this.selectedTeacherId);
        }
        this.props.printSignInCard(this.props.selectedProduct.id, studentSignInCardsData);
    }

    render() {
        return (<SignInCards
            currentSelection={this.state.currentSelection}
            disableDownload={this.state.disableDownload}
            filteredClassrooms={this.state.filteredClassrooms}
            onClassSelectionChange={this.onClassSelectionChange}
            onDownloadSignInCards={this.downloadStudentSignInCards}
            onLabelSelectionChange={this.onLabelSelectionChange}
            onTeacherSelection={this.onTeacherSelectionChange}
            selectedTeachersId={this.schoolTeachers}
            signInCardsEnum={signInCardsEnum}
            {...this.props} />);
    }
}

SignInCardsContainer.propTypes = {
    selectedProduct: PropTypes.object,
    teachers: PropTypes.array,
    classrooms: PropTypes.array,
    getProductTeachers: PropTypes.func,
    getProductClassrooms: PropTypes.func,
    printSignInCard: PropTypes.func,
    printTeacherSignInCard: PropTypes.func,
    isClassroomsLoaded: PropTypes.bool,
    isTeachersLoaded: PropTypes.bool,
    isStudentSignInCardDownloaded: PropTypes.bool,
    isTeacherSignInCardDownloaded: PropTypes.bool
};

const mapStateToProps = state => ({
    selectedProduct: state.product,
    teachers: state.signInCards.teachers,
    classrooms: state.signInCards.classrooms,
    isTeachersLoaded: state.signInCards.isTeachersLoaded,
    isClassroomsLoaded: state.signInCards.isClassroomsLoaded,
    isStudentSignInCardDownloaded: state.studentRoll.isSignInCardDownloaded,
    isTeacherSignInCardDownloaded: state.teacherRoll.isSignInCardDownloaded
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProductTeachers,
        getProductClassrooms,
        printSignInCard,
        printTeacherSignInCard
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInCardsContainer);



// WEBPACK FOOTER //
// ./app/containers/sign-in-cards/index.js